import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export function useCancelAssessmentProgress(id: number, config: Config) {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/companies/${id}/cancel_assessment`,
    config,
  );
}
